export default function FullScreenLoading() {
  return (
    <div className="flex justify-center items-center h-screen w-screen loading-pulse">
      💪
    </div>
  );
}